import { getHelpUrl } from 'gcs-common/slices/theme/themeSelectors';

const openHelp = () => (_, getState) => {
  const helpUrl = getHelpUrl(getState());
  window.open(helpUrl);
};

export default openHelp;
